/* Farmgate Honey: keep the mega menu's white panel as tall as what is in it (23 Sep 2026).
   Horizon measures an open panel once, often before its links and product cards have laid
   out, and paints the panel to that height. When the content then grows, the last rows spill
   out over the page. This watches the open panel and grows the two height variables Horizon
   reads (--submenu-height and --full-open-header-height) by the same amount. It only ever
   grows an open panel; Horizon still does all the opening, closing and animation. */
(() => {
  const header = document.querySelector('#header-component');
  if (!header || !('ResizeObserver' in window)) return;

  const px = (name) => parseFloat(header.style.getPropertyValue(name)) || 0;

  const grow = (submenu) => {
    if (!submenu.hasAttribute('data-active')) return;
    const current = px('--submenu-height');
    const height = submenu.offsetHeight;
    if (current === 0 || height <= current) return;
    header.style.setProperty('--submenu-height', `${height}px`);
    header.style.setProperty('--full-open-header-height', `${px('--full-open-header-height') + height - current}px`);
  };

  const observer = new ResizeObserver((entries) => entries.forEach((entry) => grow(entry.target)));
  header.querySelectorAll('.menu-list__submenu').forEach((submenu) => observer.observe(submenu));
})();
